import React from "react";
import { Translate } from "react-localize-redux";
import { Field, reduxForm } from "redux-form";
import { NavLink } from "reactstrap";
import { renderErrorsList } from "../../../utils/formUtils";
import InputField from "../InputField";

export class ConfirmCodeForm extends React.Component {
  handleConfirmCode = values => {
    console.log("values", values);
    this.props.confirmCodeAction(values);
  };

  render() {
    const { errors, handleSubmit, headerText } = this.props;
    return (
      <div className="col-lg-4 text-center form-margin-container">
        <h3 id="sign-in-brand">{headerText}</h3>
        <br />
        <div className="row align-items-center justify-content-center">
          <div className="col-lg-6 text-center">
            <form onSubmit={handleSubmit(this.handleConfirmCode)}>
              <Field
                label="Confirmation Code"
                hideLabel={true}
                name="userEnteredCode"
                type="number"
                id="user-code-input"
                placeholder="Enter Code Received"
                textAlign="center"
                component={InputField}
              />
              <br />
              <button type="submit" id="login-btn" className="btn btn-primary">
                <Translate id="confirmText" />
              </button>
            </form>
          </div>
        </div>
        <br />
        <NavLink href="/confirm-number" className="try-again-btn">
          Try again?
        </NavLink>
        <br />
        <ul className="list-group">{errors && renderErrorsList(errors)}</ul>
      </div>
    );
  }
}

function validate(values) {
  const errors = {};
  return errors;
}

export default reduxForm({
  validate,
  form: "ConfirmCodeForm"
})(ConfirmCodeForm);



// WEBPACK FOOTER //
// ./src/components/forms/ConfirmCodeForm/ConfirmCodeForm.jsx